module.exports = __webpack_public_path__ + "img/nftb.49b29ea5.png";